import { max, min, schema } from '@angular/forms/signals';
import { TickType } from '@setting';
import { ORDER_SETTINGS_LIMITS, OrderSettings } from './order-settings.model';

/**
 * Every number here is optional: empty is a real answer — "do not pre-fill a
 * volume", "do not step the price" — and for the two volumes it is the default.
 * `min` / `max` skip an empty (`NaN`) number, so what is left only bounds a figure
 * the trader actually typed. A stepper reading an empty تیک has no step to take and
 * leaves the price alone, which is the same thing the trader asked for by clearing it.
 */
export const orderSettingsSchema = schema<OrderSettings>(path => {
	min(path.buyQuantity, 1, { message: 'حجم پیش‌فرض خرید باید بزرگ‌تر از صفر باشد' });
	max(path.buyQuantity, ORDER_SETTINGS_LIMITS.maxQuantity, {
		message: `حجم پیش‌فرض خرید نباید بیشتر از ${ORDER_SETTINGS_LIMITS.maxQuantity.toLocaleString('en-US')} باشد`
	});

	min(path.sellQuantity, 1, { message: 'حجم پیش‌فرض فروش باید بزرگ‌تر از صفر باشد' });
	max(path.sellQuantity, ORDER_SETTINGS_LIMITS.maxQuantity, {
		message: `حجم پیش‌فرض فروش نباید بیشتر از ${ORDER_SETTINGS_LIMITS.maxQuantity.toLocaleString('en-US')} باشد`
	});

	min(path.tick, ORDER_SETTINGS_LIMITS.tickPercent.min, {
		message: `تیک قیمت نباید کمتر از ${ORDER_SETTINGS_LIMITS.tickPercent.min} باشد`
	});
	max(path.tick, ctx => resolveMaxTick(ctx.valueOf(path.tickType)), {
		message: ctx =>
			`تیک قیمت نباید بیشتر از ${resolveMaxTick(ctx.valueOf(path.tickType)).toLocaleString('en-US')} باشد`
	});
});

/** Percentage ticks are capped at 100; amount ticks use the wider bound. */
function resolveMaxTick(tickType: TickType): number {
	return tickType === TickType.Percent ? ORDER_SETTINGS_LIMITS.tickPercent.max : ORDER_SETTINGS_LIMITS.maxTickAmount;
}
